// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__26C14","overflowing":"ReadFullNote_overflowing__2vxDk"};